import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
const isCdsValue = ()=>true;
const isNonDirectional = (v)=>!/^[xytrlb]-/.test(v);
const isBorderColorToken = (v)=>!/^[xytrlb]-/.test(v) && !/^\d/.test(v) && !v.startsWith('spacing-');
const customTwMerge = extendTailwindMerge({
    prefix: 'tw-',
    classGroups: {
        'cds-bg': [
            {
                'cds-bg': [
                    isCdsValue
                ]
            }
        ],
        'cds-text': [
            {
                'cds-text': [
                    isCdsValue
                ]
            }
        ],
        'cds-border-color': [
            {
                'cds-border': [
                    isBorderColorToken
                ]
            },
            {
                'cds-border-color': [
                    isCdsValue
                ]
            }
        ],
        'cds-border-t-color': [
            {
                'cds-border-t': [
                    isCdsValue
                ]
            }
        ],
        'cds-border-r-color': [
            {
                'cds-border-r': [
                    isCdsValue
                ]
            }
        ],
        'cds-border-b-color': [
            {
                'cds-border-b': [
                    isCdsValue
                ]
            }
        ],
        'cds-border-l-color': [
            {
                'cds-border-l': [
                    isCdsValue
                ]
            }
        ],
        'cds-border-x-color': [
            {
                'cds-border-x': [
                    isCdsValue
                ]
            }
        ],
        'cds-border-y-color': [
            {
                'cds-border-y': [
                    isCdsValue
                ]
            }
        ],
        'cds-radius': [
            {
                'cds-radius': [
                    isCdsValue
                ]
            },
            {
                'cds-rounded': [
                    isCdsValue
                ]
            }
        ],
        'cds-padding': [
            {
                'cds-padding': [
                    isCdsValue
                ]
            }
        ],
        'cds-m': [
            {
                'cds-m': [
                    isNonDirectional
                ]
            }
        ],
        'cds-mx': [
            {
                'cds-mx': [
                    isCdsValue
                ]
            }
        ],
        'cds-my': [
            {
                'cds-my': [
                    isCdsValue
                ]
            }
        ],
        'cds-mt': [
            {
                'cds-mt': [
                    isCdsValue
                ]
            }
        ],
        'cds-mr': [
            {
                'cds-mr': [
                    isCdsValue
                ]
            }
        ],
        'cds-mb': [
            {
                'cds-mb': [
                    isCdsValue
                ]
            }
        ],
        'cds-ml': [
            {
                'cds-ml': [
                    isCdsValue
                ]
            }
        ],
        'cds-p': [
            {
                'cds-p': [
                    isNonDirectional
                ]
            }
        ],
        'cds-px': [
            {
                'cds-px': [
                    isCdsValue
                ]
            }
        ],
        'cds-py': [
            {
                'cds-py': [
                    isCdsValue
                ]
            }
        ],
        'cds-pt': [
            {
                'cds-pt': [
                    isCdsValue
                ]
            }
        ],
        'cds-pr': [
            {
                'cds-pr': [
                    isCdsValue
                ]
            }
        ],
        'cds-pb': [
            {
                'cds-pb': [
                    isCdsValue
                ]
            }
        ],
        'cds-pl': [
            {
                'cds-pl': [
                    isCdsValue
                ]
            }
        ],
        'cds-gap': [
            {
                'cds-gap': [
                    isNonDirectional
                ]
            }
        ],
        'cds-gap-x': [
            {
                'cds-gap-x': [
                    isCdsValue
                ]
            }
        ],
        'cds-gap-y': [
            {
                'cds-gap-y': [
                    isCdsValue
                ]
            }
        ]
    },
    conflictingClassGroups: {
        'cds-bg': [
            'bg-color'
        ],
        'bg-color': [
            'cds-bg'
        ],
        'cds-text': [
            'text-color'
        ],
        'text-color': [
            'cds-text'
        ],
        'cds-border-color': [
            'border-color',
            'cds-border-t-color',
            'cds-border-r-color',
            'cds-border-b-color',
            'cds-border-l-color',
            'cds-border-x-color',
            'cds-border-y-color'
        ],
        'border-color': [
            'cds-border-color',
            'cds-border-t-color',
            'cds-border-r-color',
            'cds-border-b-color',
            'cds-border-l-color',
            'cds-border-x-color',
            'cds-border-y-color'
        ],
        'cds-border-t-color': [
            'border-color-t'
        ],
        'border-color-t': [
            'cds-border-t-color'
        ],
        'cds-border-r-color': [
            'border-color-r'
        ],
        'border-color-r': [
            'cds-border-r-color'
        ],
        'cds-border-b-color': [
            'border-color-b'
        ],
        'border-color-b': [
            'cds-border-b-color'
        ],
        'cds-border-l-color': [
            'border-color-l'
        ],
        'border-color-l': [
            'cds-border-l-color'
        ],
        'cds-border-x-color': [
            'border-color-x',
            'border-color-r',
            'border-color-l'
        ],
        'border-color-x': [
            'cds-border-x-color'
        ],
        'cds-border-y-color': [
            'border-color-y',
            'border-color-t',
            'border-color-b'
        ],
        'border-color-y': [
            'cds-border-y-color'
        ],
        'cds-radius': [
            'rounded'
        ],
        rounded: [
            'cds-radius'
        ],
        'cds-padding': [
            'p',
            'px',
            'py',
            'pt',
            'pr',
            'pb',
            'pl',
            'cds-p',
            'cds-px',
            'cds-py',
            'cds-pt',
            'cds-pr',
            'cds-pb',
            'cds-pl'
        ],
        'cds-m': [
            'm',
            'mx',
            'my',
            'mt',
            'mr',
            'mb',
            'ml'
        ],
        m: [
            'cds-m',
            'cds-mx',
            'cds-my',
            'cds-mt',
            'cds-mr',
            'cds-mb',
            'cds-ml'
        ],
        'cds-mx': [
            'mx',
            'mr',
            'ml'
        ],
        mx: [
            'cds-mx'
        ],
        'cds-my': [
            'my',
            'mt',
            'mb'
        ],
        my: [
            'cds-my'
        ],
        'cds-mt': [
            'mt'
        ],
        mt: [
            'cds-mt'
        ],
        'cds-mr': [
            'mr'
        ],
        mr: [
            'cds-mr'
        ],
        'cds-mb': [
            'mb'
        ],
        mb: [
            'cds-mb'
        ],
        'cds-ml': [
            'ml'
        ],
        ml: [
            'cds-ml'
        ],
        'cds-p': [
            'p',
            'px',
            'py',
            'pt',
            'pr',
            'pb',
            'pl'
        ],
        p: [
            'cds-p',
            'cds-px',
            'cds-py',
            'cds-pt',
            'cds-pr',
            'cds-pb',
            'cds-pl',
            'cds-padding'
        ],
        'cds-px': [
            'px',
            'pr',
            'pl'
        ],
        px: [
            'cds-px'
        ],
        'cds-py': [
            'py',
            'pt',
            'pb'
        ],
        py: [
            'cds-py'
        ],
        'cds-pt': [
            'pt'
        ],
        pt: [
            'cds-pt'
        ],
        'cds-pr': [
            'pr'
        ],
        pr: [
            'cds-pr'
        ],
        'cds-pb': [
            'pb'
        ],
        pb: [
            'cds-pb'
        ],
        'cds-pl': [
            'pl'
        ],
        pl: [
            'cds-pl'
        ],
        'cds-gap': [
            'gap',
            'gap-x',
            'gap-y'
        ],
        gap: [
            'cds-gap'
        ],
        'cds-gap-x': [
            'gap-x'
        ],
        'gap-x': [
            'cds-gap-x'
        ],
        'cds-gap-y': [
            'gap-y'
        ],
        'gap-y': [
            'cds-gap-y'
        ]
    }
});
function cn(...inputs) {
    return customTwMerge(clsx(inputs));
}
function getFromNestedObject(obj, path, index = 0) {
    const key = path[index];
    if (!key) return '';
    const result = obj[key];
    if (!result) return '';
    if ('string' == typeof result) return result;
    return getFromNestedObject(Object(result), path, index + 1);
}
const tw = String.raw;
export { cn, getFromNestedObject, tw };
